<!-- Carriers Management Modal -->
<div class="modal-backdrop fade show" *ngIf="showModal" (click)="close()"></div>
<div class="modal fade show d-block" *ngIf="showModal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-xl modal-dialog-centered" style="max-width: 90vw;">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header border-bottom-0 pb-2">
        <h5 class="modal-title">Carriers Management</h5>
        <button type="button" class="btn-close" (click)="close()"></button>
      </div>

      <!-- Tab Navigation -->
      <div class="modal-header pt-0 pb-0 border-bottom-0">
        <ul class="nav nav-tabs w-100">
          <li class="nav-item">
            <a
              class="nav-link"
              [class.active]="activeTab === 'carriers'"
              (click)="switchTab('carriers')"
              style="cursor: pointer;">
              Carriers
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              [class.active]="activeTab === 'carrier-charges'"
              (click)="switchTab('carrier-charges')"
              style="cursor: pointer;">
              Carrier Charges
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              [class.active]="activeTab === 'charge-types'"
              (click)="switchTab('charge-types')"
              style="cursor: pointer;">
              Charge Types
            </a>
          </li>
        </ul>
      </div>

      <!-- Modal Body - Tab Content -->
      <div class="modal-body" style="min-height: 500px;">
        <!-- Carriers Tab -->
        <div *ngIf="activeTab === 'carriers'" class="tab-content-wrapper">
          <app-carriers-list-tab></app-carriers-list-tab>
        </div>

        <!-- Carrier Charges Tab -->
        <div *ngIf="activeTab === 'carrier-charges'" class="tab-content-wrapper">
          <app-carrier-charges-tab></app-carrier-charges-tab>
        </div>

        <!-- Charge Types Tab -->
        <div *ngIf="activeTab === 'charge-types'" class="tab-content-wrapper">
          <app-charge-types-tab></app-charge-types-tab>
        </div>
      </div>
    </div>
  </div>
</div>
